if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');

      this.initDotNav();
      this.initChevronNav();

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.viewer.addEventListener('slideChanged', this.updateDots.bind(this));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    getVisibleSlides() {
      return Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).filter(function(slide) {
        if (slide.classList.contains('product__media-item--variant')) return false;
        var img = slide.querySelector('img');
        return img && img.getAttribute('src');
      });
    }

    initDotNav() {
      this.dotsContainer = this.querySelector('.product__gallery-dots');
      if (!this.dotsContainer) return;

      var visibleSlides = this.getVisibleSlides();
      var self = this;

      visibleSlides.forEach(function(slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product__gallery-dot' + (slide.classList.contains('is-active') ? ' is-active' : '');
        dot.dataset.mediaId = slide.dataset.mediaId;
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        dot.addEventListener('click', function() {
          self.setActiveMedia(slide.dataset.mediaId, false);
          slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        self.dotsContainer.appendChild(dot);
      });

      this.dots = this.dotsContainer.querySelectorAll('.product__gallery-dot');
    }

    updateDots() {
      if (!this.dots || !this.dots.length) return;
      var activeSlide = this.elements.viewer.querySelector('.is-active');
      if (!activeSlide) return;
      var activeMediaId = activeSlide.dataset.mediaId;
      this.dots.forEach(function(dot) {
        dot.classList.toggle('is-active', dot.dataset.mediaId === activeMediaId);
      });
    }

    initChevronNav() {
      this.prevBtn = this.querySelector('.product__gallery-prev');
      this.nextBtn = this.querySelector('.product__gallery-next');
      if (!this.prevBtn || !this.nextBtn) return;

      var self = this;
      this.prevBtn.addEventListener('click', function() { self.navigateGallery(-1); });
      this.nextBtn.addEventListener('click', function() { self.navigateGallery(1); });
      this.updateChevrons();
    }

    updateChevrons() {
      if (!this.prevBtn || !this.nextBtn) return;
      var visibleSlides = this.getVisibleSlides();
      var activeSlide = this.elements.viewer.querySelector('.is-active');
      if (!activeSlide) return;
      var currentIndex = visibleSlides.indexOf(activeSlide);
      this.prevBtn.disabled = currentIndex <= 0;
      this.nextBtn.disabled = currentIndex >= visibleSlides.length - 1;
    }

    navigateGallery(direction) {
      var visibleSlides = this.getVisibleSlides();
      var activeSlide = this.elements.viewer.querySelector('.is-active');
      if (!activeSlide) return;
      var currentIndex = visibleSlides.indexOf(activeSlide);
      var nextIndex = Math.max(0, Math.min(visibleSlides.length - 1, currentIndex + direction));
      if (nextIndex !== currentIndex) {
        this.setActiveMedia(visibleSlides[nextIndex].dataset.mediaId, false);
        visibleSlides[nextIndex].parentElement.scrollTo({ left: visibleSlides[nextIndex].offsetLeft, behavior: 'smooth' });
      }
      this.updateChevrons();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);
      this.updateDots();
      this.updateChevrons();

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
